import { Grid } from '@mui/material';
import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { RenderDrawerContentProps } from '~/pages/layout/components/Navigation/Drawer';
import { DrawerContainer } from '~/pages/layout/components/Navigation/DrawerContainer';
import { Snackbar } from '~/pages/layout/components/Snackbar/Snackbar';
import { DRAWER_WIDTH } from './layout-constants';

export function AppLayout({ renderDrawerContent }: RenderDrawerContentProps) {
  return (
    <Grid container>
      <DrawerContainer renderDrawerContent={renderDrawerContent} />

      <Grid
        container
        flexDirection="column"
        flexWrap="nowrap"
        minHeight="100vh"
        width={{
          xs: '100%',
          lg: `calc(100% - ${DRAWER_WIDTH}px)`,
        }}
        pb={5}
        pt={{ xs: 9, sm: 10, lg: 4 }}
        px={{
          xs: 2,
          md: 4,
          lg: 6,
        }}
      >
        {/*
          No fallback because we don't want to show a flash or spinner.
          The navigation will remain visible.
        */}
        <Suspense>
          <Outlet />
        </Suspense>

        <Snackbar />
      </Grid>
    </Grid>
  );
}
